module.exports = __webpack_public_path__ + "img/info-alert.7528e1f3.png";